import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Id, ListRetrievalResponse } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  hasRetrievedList: boolean;
  list: ListRetrievalResponse;
  retrieveList(request: Boundaries["retrieveList"]["request"]): void;
}

function useListRetrieval(listId: Id): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isListRetrievalRequestPending(listId),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isListRetrievalRequestSuccess(listId),
    ),
    isRequestFailure: useSelector(() =>
      selector.isListRetrievalRequestFailure(listId),
    ),
    hasRetrievedList: useSelector(() => selector.hasRetrievedList(listId)),
    list: useSelector(() => selector.getList(listId)),
    retrieveList: core.retrieveList,
  };
}

export { useListRetrieval };
